import React, { useState } from "react";
import ModalCard from "../../../components/ModalCard";
import { useDispatch } from "react-redux";
import Card1 from "./BulkDownload/Card1";
import ModalCardWithHeaderFooter from "../../../components/Cards/ModalCardWithHeaderFooter";
import axios from "axios";
import { getAccessToken, getProfileId } from "../../../utils/validationUtils";
import {
  handleRefreshTabData,
  refreshIntransitOrderData,
  refreshReadyToShipOrderData,
} from "../../../reducers/orders/ordersSlice";
import Card2 from "./BulkDownload/Card2";

function BulkDownloadContent({ modal, setModal, data, readyToShip }) {
  const [loader, setLoader] = useState(false);
  const [activeCard, setActiveCard] = useState(1);
  const [error, setError] = useState("");

  const dispatch = useDispatch();
  const onSubmit = () => {
    const businessId = sessionStorage.getItem("selectedBusinessId");
    if (activeCard == 1) bulkDownload();
    if (activeCard == 2) {
      setModal(false);
      dispatch(handleRefreshTabData());
      if (readyToShip)
        dispatch(
          refreshReadyToShipOrderData({
            businessId,
            pageSize: 25,
            pageNo: 1,
          })
        );
      else
        dispatch(
          refreshIntransitOrderData({
            businessId,
            pageSize: 25,
            pageNo: 1,
          })
        );
    }
  };

  const bulkDownload = async () => {
    const businessId = sessionStorage.getItem("selectedBusinessId");

    // setLoader(true);

    const payloadData = data.map(({ cartId }) => cartId);

    setActiveCard(2);
    const res = await downloadInvoice({ businessId, data: payloadData });

    // setModal(false);
    // dispatch(handleRefreshTabData());
    // dispatch(
    //   refreshReadyToShipOrderData({
    //     businessId,
    //     pageSize: 20,
    //     pageNo: 1,
    //   })
    // );
    // setTimeout(() => {
    //   console.log("payloadDatapayloadData", payloadData);
    //   setLoader(false);
    //   setActiveCard(3);
    // }, 5000);
  };

  const downloadInvoice = async ({ businessId, data }) => {
    try {
      const response = await axios.post(
        "https://web.costbo.com/cart-query-side/api/v2/cart/business/bulkInvoiceShippingLabelPDF",
        data,
        {
          responseType: "blob", // Important to handle binary data
          headers: {
            Authorization: `Bearer ${getAccessToken()} `,
            profileId: `${getProfileId()}`,
            Accept: "*/*",
            businessId,
          },
        }
      );

      // Create a Blob URL and trigger the download
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: "application/pdf" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `CostBo_Invoice_Label.pdf`); // File name
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url); // Clean up
      // setActiveCard(2);
    } catch (error) {
      console.error("Error downloading the PDF:", error);
      setError("Error downloading the PDF");
    } finally {
      //   setInvoiceDownloadLoader(null);
      // setLoader(false);
    }
  };
  return (
    <ModalCard
      open={modal}
      handleClose={() => setModal(null)}
      width={data?.length > 8 ? "50%" : "40%"}
    >
      <ModalCardWithHeaderFooter
        title="Download Order Invoice and Shiping label"
        footerJC="center"
        submitText={activeCard == 1 ? "Download All" : "Ok"}
        onCancel={() => setModal(false)}
        onSubmit={onSubmit}
        loader={loader}
        hideCancel={activeCard == 2}
      >
        {activeCard == 1 && <Card1 data={data} />}
        {activeCard == 2 && <Card2 data={data} />}
      </ModalCardWithHeaderFooter>
    </ModalCard>
  );
}

export default BulkDownloadContent;
